export default __webpack_public_path__ + "static/media/startCol2.d29b0e5b.jpg";